function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import values from 'ramda/src/values';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, LANGUAGE_HEADER, SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { SEARCH_ENTITIES, SORT_BY, SORT_DIRECTION } from 'invision-core/src/constants/search.constants';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { getUiNotificationService } from 'invision-core/src/components/injectables/injector.helper';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { ApiConstants, InjectorHelper, MetadataThunkHelper, ThunkHelper } from 'invision-core';
import { INVOICE_TIMING_CONSTANTS, NOTIFICATION_TIME_LENGTH, REASON_CODES } from '../../customercare.constants';
import { ContextOfferingAction, OFFERING_CHARGE_TYPE_IDS, OFFERINGS_SEARCH_CONSTANTS } from '../constants/wizard.constants';
import CustomerCareKeys from '../../locales/keys';
import { CurrentCustomerIdSelector, RouteParams } from '../selectors/customer.selectors';
import { EditCustomerInfoSelector } from '../selectors/new.connect.wizard.selectors';
import { SelectedContractSelector } from '../selectors/contract.selectors';
import { ConvergentBillerAccountOfferingsForSelectedAccountSelector } from '../selectors/customer.convergent.biller.selectors';
import { EMPTY_STRING } from '../constants/common.constants';
export var SEARCH_AVAILABLE_OFFERINGS = {
  BEGIN: 'SEARCH_AVAILABLE_OFFERINGS_BEGIN',
  SUCCESS: 'SEARCH_AVAILABLE_OFFERINGS_SUCCESS',
  FAILURE: 'SEARCH_AVAILABLE_OFFERINGS_FAILURE'
};
var SEARCH_AVAILABLE_OFFERINGS_TYPES = [SEARCH_AVAILABLE_OFFERINGS.BEGIN, SEARCH_AVAILABLE_OFFERINGS.SUCCESS, SEARCH_AVAILABLE_OFFERINGS.FAILURE];
export var RETRIEVE_OFFERING_CONTEXT = {
  BEGIN: 'RETRIEVE_OFFERING_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_OFFERING_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_OFFERING_CONTEXT_FAILURE'
};
var RETRIEVE_OFFERING_CONTEXT_TYPES = [RETRIEVE_OFFERING_CONTEXT.BEGIN, RETRIEVE_OFFERING_CONTEXT.SUCCESS, RETRIEVE_OFFERING_CONTEXT.FAILURE];
export var RETRIEVE_OFFERING_CONTEXT_QUICK_VIEW = {
  BEGIN: 'RETRIEVE_OFFERING_CONTEXT_QUICK_VIEW_BEGIN',
  SUCCESS: 'RETRIEVE_OFFERING_CONTEXT_QUICK_VIEW_SUCCESS',
  FAILURE: 'RETRIEVE_OFFERING_CONTEXT_QUICK_VIEW_FAILURE'
};
export var RETRIEVE_ORDER_CONTEXT = {
  BEGIN: 'RETRIEVE_ORDER_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_ORDER_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_ORDER_CONTEXT_FAILURE'
};
var RETRIEVE_ORDER_CONTEXT_TYPES = [RETRIEVE_ORDER_CONTEXT.BEGIN, RETRIEVE_ORDER_CONTEXT.SUCCESS, RETRIEVE_ORDER_CONTEXT.FAILURE];
var RETRIEVE_OFFERING_CONTEXT_QUICK_VIEW_TYPES = values(RETRIEVE_OFFERING_CONTEXT_QUICK_VIEW);
export var UPDATE_CART_SUMMARY = {
  BEGIN: 'UPDATE_CART_SUMMARY_BEGIN',
  SUCCESS: 'UPDATE_CART_SUMMARY_SUCCESS',
  FAILURE: 'UPDATE_CART_SUMMARY_FAILURE'
};
var UPDATE_CART_SUMMARY_TYPES = [UPDATE_CART_SUMMARY.BEGIN, UPDATE_CART_SUMMARY.SUCCESS, UPDATE_CART_SUMMARY.FAILURE];
export var RETRIEVE_ATTRIBUTES = {
  BEGIN: 'RETRIEVE_ATTRIBUTES_BEGIN',
  SUCCESS: 'RETRIEVE_ATTRIBUTES_SUCCESS',
  FAILURE: 'RETRIEVE_ATTRIBUTES_FAILURE'
};
var RETRIEVE_ATTRIBUTES_TYPES = [RETRIEVE_ATTRIBUTES.BEGIN, RETRIEVE_ATTRIBUTES.SUCCESS, RETRIEVE_ATTRIBUTES.FAILURE];
export var CALCULATE_COS_ORDER_QUOTE = {
  BEGIN: 'CALCULATE_COS_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_COS_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_COS_ORDER_QUOTE_FAILURE'
};
var CALCULATE_COS_ORDER_QUOTE_TYPES = [CALCULATE_COS_ORDER_QUOTE.BEGIN, CALCULATE_COS_ORDER_QUOTE.SUCCESS, CALCULATE_COS_ORDER_QUOTE.FAILURE];
export var CALCULATE_OFFERING_ORDER_QUOTE = {
  BEGIN: 'CALCULATE_OFFERING_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_OFFERING_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_OFFERING_ORDER_QUOTE_FAILURE'
};
var CALCULATE_OFFERING_ORDER_QUOTE_TYPES = [CALCULATE_OFFERING_ORDER_QUOTE.BEGIN, CALCULATE_OFFERING_ORDER_QUOTE.SUCCESS, CALCULATE_OFFERING_ORDER_QUOTE.FAILURE];
export var RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE = {
  BEGIN: 'RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE_BEGIN',
  SUCCESS: 'RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE_SUCCESS',
  FAILURE: 'RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE_FAILURE'
};
var RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE_TYPES = [RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE.BEGIN, RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE.SUCCESS, RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE.FAILURE];
export var RETRIEVE_OFFERING_ORDER_QUOTE = {
  BEGIN: 'RETRIEVE_OFFERING_ORDER_QUOTE_BEGIN',
  SUCCESS: 'RETRIEVE_OFFERING_ORDER_QUOTE_SUCCESS',
  FAILURE: 'RETRIEVE_OFFERING_ORDER_QUOTE_FAILURE'
};
var RETRIEVE_OFFERING_ORDER_QUOTE_TYPES = [RETRIEVE_OFFERING_ORDER_QUOTE.BEGIN, RETRIEVE_OFFERING_ORDER_QUOTE.SUCCESS, RETRIEVE_OFFERING_ORDER_QUOTE.FAILURE];
export var RETRIEVE_ORDER_QUOTE = {
  BEGIN: 'RETRIEVE_ORDER_QUOTE_BEGIN',
  SUCCESS: 'RETRIEVE_ORDER_QUOTE_SUCCESS',
  FAILURE: 'RETRIEVE_ORDER_QUOTE_FAILURE'
};
var RETRIEVE_ORDER_QUOTE_TYPES = [RETRIEVE_ORDER_QUOTE.BEGIN, RETRIEVE_ORDER_QUOTE.SUCCESS, RETRIEVE_ORDER_QUOTE.FAILURE];
export var CALCULATE_ORDER_QUOTE = {
  BEGIN: 'CALCULATE_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_ORDER_QUOTE_FAILURE'
};
var CALCULATE_ORDER_QUOTE_TYPES = [CALCULATE_ORDER_QUOTE.BEGIN, CALCULATE_ORDER_QUOTE.SUCCESS, CALCULATE_ORDER_QUOTE.FAILURE];
export var RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT = {
  BEGIN: 'RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT_FAILURE'
};
var RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT_TYPES = [RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT.BEGIN, RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT.SUCCESS, RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT.FAILURE];
export var SUBMIT_ORDER = {
  BEGIN: 'SUBMIT_ORDER_BEGIN',
  SUCCESS: 'SUBMIT_ORDER_SUCCESS',
  FAILURE: 'SUBMIT_ORDER_FAILURE'
};
var SUBMIT_ORDER_EVENTS = [SUBMIT_ORDER.BEGIN, SUBMIT_ORDER.SUCCESS, SUBMIT_ORDER.FAILURE];
export var SEARCH_INVENTORY = {
  BEGIN: 'SEARCH_INVENTORY_BEGIN',
  SUCCESS: 'SEARCH_INVENTORY_SUCCESS',
  FAILURE: 'SEARCH_INVENTORY_FAILURE'
};
var SEARCH_INVENTORY_EVENTS = [SEARCH_INVENTORY.BEGIN, SEARCH_INVENTORY.SUCCESS, SEARCH_INVENTORY.FAILURE];
export var SEARCH_INVENTORIES_AVAILABILITY = {
  BEGIN: 'SEARCH_INVENTORIES_AVAILABILITY_BEGIN',
  SUCCESS: 'SEARCH_INVENTORIES_AVAILABILITY_SUCCESS',
  FAILURE: 'SEARCH_INVENTORIES_AVAILABILITY_FAILURE'
};
export var SEARCH_INVENTORIES_AVAILABILITY_EVENTS = [SEARCH_INVENTORIES_AVAILABILITY.BEGIN, SEARCH_INVENTORIES_AVAILABILITY.SUCCESS, SEARCH_INVENTORIES_AVAILABILITY.FAILURE];
export var RETRIEVE_INVENTORY_AVAILABILITY = {
  BEGIN: 'RETRIEVE_INVENTORY_AVAILABILITY_BEGIN',
  SUCCESS: 'RETRIEVE_INVENTORY_AVAILABILITY_SUCCESS',
  FAILURE: 'RETRIEVE_INVENTORY_AVAILABILITY_FAILURE'
};
export var RETRIEVE_INVENTORY_AVAILABILITY_EVENTS = [RETRIEVE_INVENTORY_AVAILABILITY.BEGIN, RETRIEVE_INVENTORY_AVAILABILITY.SUCCESS, RETRIEVE_INVENTORY_AVAILABILITY.FAILURE];
export var UPDATE_MULTI_OFFER_SHOPPING_CART = {
  BEGIN: 'UPDATE_MULTI_OFFER_SHOPPING_CART_BEGIN',
  SUCCESS: 'UPDATE_MULTI_OFFER_SHOPPING_CART_SUCCESS',
  FAILURE: 'UPDATE_MULTI_OFFER_SHOPPING_CART_FAILURE'
};
export var UPDATE_MULTI_OFFER_SHOPPING_CART_EVENTS = [UPDATE_MULTI_OFFER_SHOPPING_CART.BEGIN, UPDATE_MULTI_OFFER_SHOPPING_CART.SUCCESS, UPDATE_MULTI_OFFER_SHOPPING_CART.FAILURE];
export var REPLACE_MULTI_OFFER_SHOPPING_CART = {
  BEGIN: 'REPLACE_MULTI_OFFER_SHOPPING_CART_BEGIN',
  SUCCESS: 'REPLACE_MULTI_OFFER_SHOPPING_CART_SUCCESS',
  FAILURE: 'REPLACE_MULTI_OFFER_SHOPPING_CART_FAILURE'
};
export var REPLACE_MULTI_OFFER_SHOPPING_CART_EVENTS = [REPLACE_MULTI_OFFER_SHOPPING_CART.BEGIN, REPLACE_MULTI_OFFER_SHOPPING_CART.SUCCESS, REPLACE_MULTI_OFFER_SHOPPING_CART.FAILURE];
export var SEARCH_SERVICE_FEATURES = {
  BEGIN: 'SEARCH_SERVICE_FEATURES_BEGIN',
  SUCCESS: 'SEARCH_SERVICE_FEATURES_SUCCESS',
  FAILURE: 'SEARCH_SERVICE_FEATURES_FAILURE'
};
var SEARCH_SERVICE_FEATURES_EVENTS = [SEARCH_SERVICE_FEATURES.BEGIN, SEARCH_SERVICE_FEATURES.SUCCESS, SEARCH_SERVICE_FEATURES.FAILURE];
export var RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES = {
  BEGIN: 'RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES_BEGIN',
  SUCCESS: 'RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES_SUCCESS',
  FAILURE: 'RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES_FAILURE'
};
var RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES_EVENTS = [RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES.BEGIN, RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES.SUCCESS, RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES.FAILURE];
export var GET_SERVICE_FEATURE_PRODUCT_METADATA = {
  BEGIN: 'GET_SERVICE_FEATURE_PRODUCT_METADATA_BEGIN',
  SUCCESS: 'GET_SERVICE_FEATURE_PRODUCT_METADATA_SUCCESS',
  FAILURE: 'GET_SERVICE_FEATURE_PRODUCT_METADATA_FAILURE'
};
var GET_SERVICE_FEATURE_PRODUCT_METADATA_EVENTS = [GET_SERVICE_FEATURE_PRODUCT_METADATA.BEGIN, GET_SERVICE_FEATURE_PRODUCT_METADATA.SUCCESS, GET_SERVICE_FEATURE_PRODUCT_METADATA.FAILURE];
export var GET_STANDALONE_PRODUCT_METADATA = {
  BEGIN: 'GET_STANDALONE_PRODUCT_METADATA_BEGIN',
  SUCCESS: 'GET_STANDALONE_PRODUCT_METADATA_SUCCESS',
  FAILURE: 'GET_STANDALONE_PRODUCT_METADATA_FAILURE'
};
var GET_STANDALONE_PRODUCT_METADATA_EVENTS = [GET_STANDALONE_PRODUCT_METADATA.BEGIN, GET_STANDALONE_PRODUCT_METADATA.SUCCESS, GET_STANDALONE_PRODUCT_METADATA.FAILURE];
export var SEND_INVENTORY_TO_STORE = {
  BEGIN: 'SEND_INVENTORY_TO_STORE_BEGIN',
  SUCCESS: 'SEND_INVENTORY_TO_STORE_SUCCESS',
  FAILURE: 'SEND_INVENTORY_TO_STORE_FAILURE'
};
var SEND_INVENTORY_TO_STORE_EVENTS = [SEND_INVENTORY_TO_STORE.BEGIN, SEND_INVENTORY_TO_STORE.SUCCESS, SEND_INVENTORY_TO_STORE.FAILURE];
export var RETRIEVE_TRANSFER_FROM_SUBSCRIBER = {
  BEGIN: 'RETRIEVE_TRANSFER_FROM_SUBSCRIBER_BEGIN',
  SUCCESS: 'RETRIEVE_TRANSFER_FROM_SUBSCRIBER_SUCCESS',
  FAILURE: 'RETRIEVE_TRANSFER_FROM_SUBSCRIBER_FAILURE'
};
var RETRIEVE_TRANSFER_FROM_SUBSCRIBER_EVENTS = [RETRIEVE_TRANSFER_FROM_SUBSCRIBER.BEGIN, RETRIEVE_TRANSFER_FROM_SUBSCRIBER.SUCCESS, RETRIEVE_TRANSFER_FROM_SUBSCRIBER.FAILURE];
export var CLEAR_OFFERING_ORDER_QUOTE = 'CLEAR_OFFERING_ORDER_QUOTE';
export var CLEAR_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES = 'CLEAR_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES';
export var CLEAR_QUOTE = 'CLEAR_QUOTE';
export var CLEAR_SUMMARY_QUOTE = 'CLEAR_SUMMARY_QUOTE';
export var DECISION_OPTION_ITEM_QUANTITY_CHANGED = 'DECISION_OPTION_ITEM_QUANTITY_CHANGED';
export var DECISION_OPTION_QUANTITY_CHANGED = 'DECISION_OPTION_QUANTITY_CHANGED';
export var DECISION_OPTION_SELECTED = 'DECISION_OPTION_SELECTED';
export var DECISION_OPTION_SERVICE_IDS_FOR_REMOVAL_SELECTED = 'DECISION_OPTION_SERVICE_IDS_FOR_REMOVAL_SELECTED';
export var DISCOUNT_OVERRIDE_CHANGED = 'DISCOUNT_OVERRIDE_CHANGED';
export var DISCOUNT_OVERRIDE_CLEAR = 'DISCOUNT_OVERRIDE_CLEAR';
export var MAX_ONE_NON_DECISION_GROUP_OPTION_QUANTITY_CHANGED = 'MAX_ONE_NON_DECISION_GROUP_OPTION_QUANTITY_CHANGED';
export var RESET_AVAILABLE_INVENTORY_INFORMATION = 'RESET_AVAILABLE_INVENTORY_INFORMATION';
export var RESET_INVENTORY_STORE_PICKUP_DETAILS = 'RESET_INVENTORY_STORE_PICKUP_DETAILS';
export var SAVE_INVENTORY_STORE_PICKUP_DETAILS = 'SAVE_INVENTORY_STORE_PICKUP_DETAILS';
export var SET_DECISIONS_SELECTED_PAGE = 'SET_DECISIONS_SELECTED_PAGE';
export var SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export var SET_SELECTED_BRI_SELECTED_DISCOUNTS = 'SET_SELECTED_BRI_SELECTED_DISCOUNTS';
export var SET_SELECTED_OFFER_NAME = 'SET_SELECTED_OFFER_NAME';
export var SET_OFF_CYCLE_ALIGNMENT_SUBSCRIBER_PRODUCT_DATA = 'SET_OFF_CYCLE_ALIGNMENT_SUBSCRIBER_PRODUCT_DATA';
export var addSubscriberHeaders = function addSubscriberHeaders(customerId, customerLanguage) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  headers[SUBSCRIBER_ID_HEADER] = customerId;
  if (customerLanguage) {
    headers[CUSTOM_SUBSCRIBER_LANGUAGE_HEADER] = customerLanguage;
  }
  return headers;
};
export var retrieveInventoryAvailabilityPromise = function retrieveInventoryAvailabilityPromise(dispatch, request) {
  return ThunkHelper(dispatch, RETRIEVE_INVENTORY_AVAILABILITY_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveInventoryAvailability',
    data: request
  }, request);
};
var searchInventoriesAvailabilityPromise = function searchInventoriesAvailabilityPromise(dispatch, request) {
  return ThunkHelper(dispatch, SEARCH_INVENTORIES_AVAILABILITY_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchInventoryAvailability',
    data: request
  }, request);
};
export var searchInventoriesAvailability = function searchInventoriesAvailability(request) {
  return function (dispatch) {
    return searchInventoriesAvailabilityPromise(dispatch, request);
  };
};
export var retrieveMultipleInventoryAvailabilityPromises = function retrieveMultipleInventoryAvailabilityPromises(dispatch, inventoryAvailabilityRequests) {
  dispatch(resetAvailableInventoryInformation());
  return Promise.all(inventoryAvailabilityRequests.map(function (combo) {
    return retrieveInventoryAvailabilityPromise(dispatch, combo);
  }));
};
export var searchAvailableOfferingsPromise = function searchAvailableOfferingsPromise(dispatch, searchOfferingsParam, requestObject, customerLanguage, customerId) {
  var params = {
    method: 'post',
    url: 'SubscriberManagement/SearchOfferings',
    data: searchOfferingsParam,
    headers: addSubscriberHeaders(customerId, customerLanguage)
  };
  return ThunkHelper(dispatch, SEARCH_AVAILABLE_OFFERINGS_TYPES, params, requestObject);
};
export var searchAvailableOfferings = function searchAvailableOfferings(searchOfferingsParam, requestObject, customerLanguage, customerId) {
  return function (dispatch) {
    return searchAvailableOfferingsPromise(dispatch, searchOfferingsParam, requestObject, customerLanguage, customerId);
  };
};
export var retrieveOrderContext = function retrieveOrderContext(transferFromSubscriberId, customerId) {
  var isGroupOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var shoppingCart = arguments.length > 3 ? arguments[3] : undefined;
  return function (dispatch) {
    return retrieveOrderContextPromise(dispatch, transferFromSubscriberId, customerId, isGroupOrder, shoppingCart);
  };
};
export var retrieveOrderContextPromise = function retrieveOrderContextPromise(dispatch, transferFromSubscriberId, customerId, isGroupOrder, shoppingCart) {
  var _shoppingCart$Items;
  var params = {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrderContext',
    headers: addSubscriberHeaders(customerId),
    data: {
      TransferFromSubscriberId: transferFromSubscriberId || undefined,
      IsGroupOrder: isGroupOrder,
      ShoppingCart: shoppingCart !== null && shoppingCart !== void 0 && (_shoppingCart$Items = shoppingCart.Items) !== null && _shoppingCart$Items !== void 0 && _shoppingCart$Items.length ? shoppingCart : undefined
    }
  };
  return ThunkHelper(dispatch, RETRIEVE_ORDER_CONTEXT_TYPES, params);
};
export var retrieveOfferingContextPromise = function retrieveOfferingContextPromise(dispatch, offeringId, customerId, retrieveAttributes) {
  var completedDecisions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var isConvergentBiller = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var segmentationContext = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var customerLanguage = arguments.length > 7 ? arguments[7] : undefined;
  var subtenantId = arguments.length > 8 ? arguments[8] : undefined;
  var changeOfferingInstanceId = arguments.length > 9 ? arguments[9] : undefined;
  var pickupId = arguments.length > 10 ? arguments[10] : undefined;
  var contextOfferingAction = changeOfferingInstanceId ? ContextOfferingAction.TRANSITION : ContextOfferingAction.ADD;
  var data = {
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    CompletedDecisionsList: completedDecisions,
    ContractId: getContractId(),
    Offerings: [{
      Action: contextOfferingAction,
      OfferingId: offeringId,
      OfferingInstanceId: changeOfferingInstanceId || undefined
    }],
    PickupId: pickupId || undefined,
    RetrieveServiceAttributes: retrieveAttributes,
    SegmentationContext: segmentationContext,
    UseSavedShoppingCart: !!changeOfferingInstanceId
  };
  if (subtenantId) {
    data['Subtenants'] = [subtenantId];
  }
  var params = {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: addSubscriberHeaders(customerId, customerLanguage),
    data: data
  };
  return ThunkHelper(dispatch, RETRIEVE_OFFERING_CONTEXT_TYPES, params);
};
export var retrieveOfferingContextPromiseWithOptions = function retrieveOfferingContextPromiseWithOptions(dispatch, offeringId, customerId, options) {
  var retrieveAttributes = options.retrieveAttributes,
    completedDecisions = options.completedDecisions || [],
    isConvergentBiller = options.isConvergentBiller,
    transitionContext = options.transitionContext,
    contextOfferingAction = options.transitionContext ? ContextOfferingAction.TRANSITION : options.contextOfferingAction,
    segmentationContext = options.segmentationContext || [],
    grandfatherPricingPlans = options.grandfatherPricingPlans || true,
    subtenantId = options.subtenantId;
  var data = {
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    CompletedDecisionsList: completedDecisions,
    ContractId: getContractId(),
    Offerings: [{
      Action: contextOfferingAction,
      OfferingId: offeringId
    }],
    RetrieveServiceAttributes: retrieveAttributes,
    SegmentationContext: segmentationContext,
    GrandfatherPricingPlans: grandfatherPricingPlans
  };
  if (subtenantId) {
    data['Subtenants'] = [subtenantId];
  }
  var params = {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: data
  };
  if (transitionContext) {
    params.data.TransitionOutcomes = transitionContext.Outcomes;
  }
  return ThunkHelper(dispatch, RETRIEVE_OFFERING_CONTEXT_TYPES, params);
};
export var retrieveOfferingContextQuickView = function retrieveOfferingContextQuickView(offeringId) {
  return function (dispatch, getState) {
    var state = getState();
    var isDbss = IsDbss(state);
    var customerId = CurrentCustomerIdSelector(state);
    var newConnectCustomer = EditCustomerInfoSelector(state);
    var routeParams = RouteParams(state);
    var customerLanguage, subtenantId;
    if (!routeParams.customerId) {
      customerLanguage = newConnectCustomer.Language;
      subtenantId = newConnectCustomer.SubtenantId;
    }
    return retrieveOfferingContextQuickViewPromise(dispatch, offeringId, customerId, isDbss, customerLanguage, subtenantId);
  };
};
export var retrieveOfferingContextQuickViewPromise = function retrieveOfferingContextQuickViewPromise(dispatch, offeringId, customerId, isConvergentBiller, customerLanguage, subtenantId) {
  var data = {
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    OrderContractInstance: getContractInstance(offeringId),
    Offerings: [{
      Action: ContextOfferingAction.ADD,
      OfferingId: offeringId
    }],
    SegmentationContext: getSegmentationContext(),
    RetrievePhysicalInventoryDecisions: false,
    RetrieveServiceAttributes: false
  };
  if (subtenantId) {
    data['Subtenants'] = [subtenantId];
  }
  return ThunkHelper(dispatch, RETRIEVE_OFFERING_CONTEXT_QUICK_VIEW_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: addSubscriberHeaders(customerId, customerLanguage),
    data: data
  });
};
export var updateCartSummaryPromise = function updateCartSummaryPromise(dispatch, offeringId, offeringInstanceId) {
  var completedDecisions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var isModify = arguments.length > 4 ? arguments[4] : undefined;
  var customerId = arguments.length > 5 ? arguments[5] : undefined;
  var contextOfferingAction = arguments.length > 6 ? arguments[6] : undefined;
  var transitionContext = arguments.length > 7 ? arguments[7] : undefined;
  var isConvergentBiller = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
  var customerLanguage = arguments.length > 9 ? arguments[9] : undefined;
  var subtenantId = arguments.length > 10 ? arguments[10] : undefined;
  var postalCode = arguments.length > 11 ? arguments[11] : undefined;
  var pickupId = arguments.length > 12 ? arguments[12] : undefined;
  var changeOfferingInstanceId = arguments.length > 13 ? arguments[13] : undefined;
  var useSavedShoppingCart = arguments.length > 14 ? arguments[14] : undefined;
  var data = {
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    CompletedDecisionsList: completedDecisions,
    ContractId: getContractId(),
    Offerings: [{
      Action: contextOfferingAction || (isModify ? ContextOfferingAction.MODIFY : changeOfferingInstanceId ? ContextOfferingAction.TRANSITION : ContextOfferingAction.ADD),
      OfferingId: offeringId,
      OfferingInstanceId: changeOfferingInstanceId || offeringInstanceId || undefined
    }],
    OrderContractInstance: getContractInstance(offeringId),
    PickupId: pickupId,
    RetrievePhysicalInventoryDecisions: false,
    RetrieveServiceAttributes: false,
    SegmentationContext: getSegmentationContext(),
    UseSavedShoppingCart: useSavedShoppingCart || !!changeOfferingInstanceId
  };
  if (subtenantId) {
    data['Subtenants'] = [subtenantId];
  }
  var params = {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: addSubscriberHeaders(customerId, customerLanguage),
    data: data
  };
  if (transitionContext) {
    params.data.TransitionOutcomes = transitionContext.Outcomes;
  }
  return ThunkHelper(dispatch, UPDATE_CART_SUMMARY_TYPES, params);
};
var getSegmentationContext = function getSegmentationContext() {
  var $ngRedux = InjectorHelper.getNgReduxService();
  var state = $ngRedux.getState();
  var newConnectCustomer = EditCustomerInfoSelector(state);
  var routeParams = RouteParams(state);
  var postalCode = routeParams.customerId ? null : newConnectCustomer.postalCode;
  var subscriberCategory = routeParams.customerId ? null : newConnectCustomer.Category;
  var subscriberType = routeParams.customerId ? null : newConnectCustomer.SubscriberTypeCode;
  return [{
    'Key': 'zipcode',
    'Value': postalCode
  }, {
    'Key': 'subscriber_category',
    'Value': subscriberCategory
  }, {
    'Key': 'subscriber_type',
    'Value': subscriberType
  }];
};
export var retrieveAttributesPromise = function retrieveAttributesPromise(_ref) {
  var changeOfferingInstanceId = _ref.changeOfferingInstanceId,
    _ref$completedDecisio = _ref.completedDecisions,
    completedDecisions = _ref$completedDecisio === void 0 ? [] : _ref$completedDecisio,
    customerId = _ref.customerId,
    customerLanguage = _ref.customerLanguage,
    dispatch = _ref.dispatch,
    _ref$isConvergentBill = _ref.isConvergentBiller,
    isConvergentBiller = _ref$isConvergentBill === void 0 ? true : _ref$isConvergentBill,
    isEditOffer = _ref.isEditOffer,
    _ref$isReconnectActio = _ref.isReconnectAction,
    isReconnectAction = _ref$isReconnectActio === void 0 ? false : _ref$isReconnectActio,
    offeringId = _ref.offeringId,
    offeringInstanceId = _ref.offeringInstanceId,
    pickupId = _ref.pickupId,
    subscriberSubtenantId = _ref.subscriberSubtenantId,
    transitionOutcomes = _ref.transitionOutcomes,
    useSavedShoppingCart = _ref.useSavedShoppingCart;
  var offeringAction;
  if (offeringInstanceId && transitionOutcomes) {
    offeringAction = ContextOfferingAction.TRANSITION;
  } else if (offeringInstanceId && isEditOffer) {
    offeringAction = isReconnectAction ? ContextOfferingAction.RECONNECT : ContextOfferingAction.MODIFY;
  } else if (changeOfferingInstanceId) {
    offeringAction = ContextOfferingAction.TRANSITION;
  } else {
    offeringAction = ContextOfferingAction.ADD;
  }
  var data = {
    AdditionalShoppingCartUpdate: !isConvergentBiller,
    CompletedDecisionsList: completedDecisions,
    ContractId: getContractId(),
    OrderContractInstance: getContractInstance(offeringId),
    Offerings: [{
      Action: offeringAction,
      OfferingId: offeringId,
      OfferingInstanceId: changeOfferingInstanceId || offeringInstanceId
    }],
    PickupId: pickupId || undefined,
    RetrieveDeliveryDecisions: true,
    RetrievePhysicalInventoryDecisions: true,
    RetrieveServiceAttributes: true,
    SegmentationContext: getSegmentationContext(),
    TransitionOutcomes: transitionOutcomes,
    UseSavedShoppingCart: !!changeOfferingInstanceId || useSavedShoppingCart
  };
  if (subscriberSubtenantId) {
    data['Subtenants'] = [subscriberSubtenantId];
  }
  return ThunkHelper(dispatch, RETRIEVE_ATTRIBUTES_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: addSubscriberHeaders(customerId, customerLanguage),
    data: data
  }, {
    changeOfferingInstanceId: changeOfferingInstanceId
  });
};
export var submitOrderPromise = function submitOrderPromise(dispatch, customerInfo, shoppingCart, paymentInfo, billCycleName, executionOptions, recordPaymentInformation, isTransfer, additionalProperties) {
  var shippingInfo = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : {};
  var orderDetails = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : {};
  var offerAdditionalProperties = arguments.length > 11 ? arguments[11] : undefined;
  var customerId = customerInfo.Id,
    paymentInfoArray = paymentInfo ? [paymentInfo] : [];
  return ThunkHelper(dispatch, SUBMIT_ORDER_EVENTS, {
    method: 'post',
    url: isTransfer ? 'SubscriberManagement/SubmitTransferOrder' : 'SubscriberManagement/SubmitOrder',
    //Same promise because schema/requirements are the same
    headers: addSubscriberHeaders(customerId, customerInfo.Language),
    data: {
      AdditionalProperties: additionalProperties || null,
      BillCycleName: billCycleName && billCycleName !== '' ? billCycleName : null,
      ContractId: getContractId(),
      ExecutionDate: executionOptions.specifiedDate || undefined,
      ExecutionDateIntention: executionOptions.effective || undefined,
      OrderComment: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.comment) || null,
      PaymentInstruments: paymentInfoArray,
      ReasonCode: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.reasonCode) || null,
      ShoppingCart: shoppingCart,
      RecordPaymentInformation: recordPaymentInformation,
      UseDefaults: true,
      ShippingAddressId: shippingInfo.addressId || undefined,
      ShippingAddress: shippingInfo.address || undefined,
      ShippingMethodId: shippingInfo.methodId || undefined,
      ShipToName: shippingInfo.shipTo || undefined,
      OrderedOfferingAdditionalProperties: !isTransfer && offerAdditionalProperties ? offerAdditionalProperties : null
    }
  });
};
export var calculateChangeOfServiceOrderQuoteRequestPromise = function calculateChangeOfServiceOrderQuoteRequestPromise(dispatch, customerId, addItems, modifyItems, removeItems, offeringId, offeringInstanceId, changesEffective) {
  var toOfferId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var reasonCode = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var executionOptions = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : {};
  var isShipping = arguments.length > 11 ? arguments[11] : undefined;
  var shippingInfo = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : {};
  var data = {
    AddItems: addItems,
    ExecutionDate: executionOptions.specifiedDate,
    ExecutionDateIntention: executionOptions.effective,
    ModifyItems: modifyItems,
    RemoveItems: removeItems,
    OfferingId: offeringId,
    OfferingInstanceId: offeringInstanceId,
    ChangeImmediately: true,
    ReturnSubscriptionPreviews: true,
    IncludeShippingMethods: isShipping,
    ShippingMethodId: shippingInfo.methodId || undefined,
    ShippingAddressId: shippingInfo.addressId || undefined
  };
  if (reasonCode) {
    data.ReasonCode = reasonCode;
  }
  if (+changesEffective === INVOICE_TIMING_CONSTANTS.INVOICE_ON_CYCLE) {
    data.ChangeImmediately = false;
  }
  if (toOfferId) {
    data.TransitionOfferingId = toOfferId;
  }
  return ThunkHelper(dispatch, CALCULATE_COS_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CalculateChangeOfServiceOrderQuote',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
export var retrieveOrderQuote = function retrieveOrderQuote(customerId, quoteId) {
  return function (dispatch) {
    return retrieveOrderQuotePromise(dispatch, customerId, quoteId);
  };
};
export var retrieveOrderQuotePromise = function retrieveOrderQuotePromise(dispatch, customerId, quoteId) {
  return ThunkHelper(dispatch, RETRIEVE_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrderQuote',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      QuoteId: quoteId
    }
  }, {
    calculateTaxesInQuote: true
  });
};
export var calculateOfferingOrderQuotePromise = function calculateOfferingOrderQuotePromise(dispatch, customer, shoppingCart, billCycleName) {
  var executionOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var shippingInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var isShipping = arguments.length > 6 ? arguments[6] : undefined;
  var bypassQuote = arguments.length > 7 ? arguments[7] : undefined;
  return ThunkHelper(dispatch, CALCULATE_OFFERING_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CalculateOfferingOrderQuote',
    headers: addSubscriberHeaders(customer.Id, customer.Language),
    data: {
      // DBSS does not use the CalculateTaxes field (it always calculates taxes).
      BillCycleName: billCycleName && billCycleName !== EMPTY_STRING ? billCycleName : null,
      CalculateShipping: false,
      // True is ITV only
      CalculateQuoteOverridingConfiguration: bypassQuote,
      ConvergentBillerAddress: !(customer.country && customer.postalCode && customer.stateRegionProvince && customer.addressLine1) ? undefined : {
        Name: 'Service Address',
        City: customer.city,
        Country: customer.country,
        DefaultBilling: true,
        DefaultHome: true,
        DefaultPostal: true,
        DefaultService: true,
        LineOne: customer.addressLine1,
        LineTwo: customer.addressLine2 || undefined,
        PostalCode: customer.postalCode,
        State: customer.stateRegionProvince
      },
      ExecutionDate: executionOptions.specifiedDate,
      ExecutionDateIntention: executionOptions.effective,
      ShoppingCart: shoppingCart,
      ShippingMethodId: shippingInfo.methodId || undefined,
      IncludeShippingMethods: isShipping,
      TaxExemption: Object.assign({
        WholesaleFlag: customer.WholesaleFlag || false
      }, customer.TaxExemption)
    }
  });
};
export var calculateOfferingOrderQuote = function calculateOfferingOrderQuote(customer, shoppingCart, billCycleName, executionOptions) {
  var shippingInfo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var isShipping = arguments.length > 5 ? arguments[5] : undefined;
  var bypassQuote = arguments.length > 6 ? arguments[6] : undefined;
  return function (dispatch) {
    return calculateOfferingOrderQuotePromise(dispatch, customer, shoppingCart, billCycleName, executionOptions, shippingInfo, isShipping, bypassQuote);
  };
};
var retrieveOffCycleNextRenewalSchedulesPromise = function retrieveOffCycleNextRenewalSchedulesPromise(dispatch, customerId, addItems, modifyItems, removeItems) {
  return ThunkHelper(dispatch, RETRIEVE_OFFCYCLE_NEXT_RENEWAL_SCHEDULE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOffCycleNextRenewalSchedules',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      AddItems: addItems,
      ModifyItems: modifyItems,
      RemoveItems: removeItems
    }
  });
};
export var retrieveOffCycleNextRenewalSchedules = function retrieveOffCycleNextRenewalSchedules(customerId) {
  var addItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var modifyItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var removeItems = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return function (dispatch) {
    return retrieveOffCycleNextRenewalSchedulesPromise(dispatch, customerId, addItems, modifyItems, removeItems);
  };
};
var retrieveOfferingOrderQuotePromise = function retrieveOfferingOrderQuotePromise(dispatch, customerId, quoteId) {
  return ThunkHelper(dispatch, RETRIEVE_OFFERING_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingOrderQuote',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      QuoteId: quoteId
    }
  });
};
export var retrieveOfferingOrderQuote = function retrieveOfferingOrderQuote(customerId, quoteId) {
  return function (dispatch) {
    return retrieveOfferingOrderQuotePromise(dispatch, customerId, quoteId);
  };
};
export var calculateChangeOfServiceOfferingOrderQuotePromise = function calculateChangeOfServiceOfferingOrderQuotePromise(dispatch, customer, offeringId, addItems, removeItems, modifiedItems) {
  var executionOptions = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var reasonCode = arguments.length > 7 ? arguments[7] : undefined;
  var shippingInfo = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
  var isShipping = arguments.length > 9 ? arguments[9] : undefined;
  var bypassQuote = arguments.length > 10 ? arguments[10] : undefined;
  return ThunkHelper(dispatch, CALCULATE_OFFERING_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CalculateChangeOfServiceOfferingOrderQuote',
    headers: addSubscriberHeaders(customer.Id, customer.Language),
    data: {
      AddItems: addItems,
      CalculateQuoteOverridingConfiguration: bypassQuote,
      ExecutionDate: executionOptions.specifiedDate,
      ExecutionDateIntention: executionOptions.effective,
      TransitionOfferingId: offeringId,
      RemoveItems: removeItems,
      ModifyItems: modifiedItems || [],
      ReasonCode: reasonCode || undefined,
      IncludeShippingMethods: isShipping,
      ShippingMethodId: shippingInfo.methodId || undefined,
      ShippingAddressId: shippingInfo.addressId || undefined
    }
  });
};
export var calculateChangeOfServiceOfferingOrderQuote = function calculateChangeOfServiceOfferingOrderQuote(customer, offeringId, addItems, removeItems, modifiedItems) {
  var executionOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var isReconnectAction = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var shippingInfo = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  var isShipping = arguments.length > 8 ? arguments[8] : undefined;
  var bypassQuote = arguments.length > 9 ? arguments[9] : undefined;
  return function (dispatch) {
    var reasonCode = isReconnectAction ? convertStringToNumber(REASON_CODES.RECONNECT) : executionOptions.disconnectReason;
    return calculateChangeOfServiceOfferingOrderQuotePromise(dispatch, customer, offeringId, addItems, removeItems, modifiedItems, executionOptions, reasonCode, shippingInfo, isShipping, bypassQuote);
  };
};
export var clearOfferingOrderQuote = function clearOfferingOrderQuote() {
  return {
    type: CLEAR_OFFERING_ORDER_QUOTE
  };
};
export var setPageNumber = function setPageNumber(pageNum) {
  return {
    type: SET_PAGE_NUMBER,
    payload: pageNum
  };
};
export var SET_CHECKOUT_FORM_VALIDATION = 'SET_CHECKOUT_FORM_VALIDATION';
export var setCheckoutDetailsValidation = function setCheckoutDetailsValidation(payload) {
  return {
    type: SET_CHECKOUT_FORM_VALIDATION,
    payload: payload
  };
};
export var retrieveBillerRuleInstanceDiscountContext = function retrieveBillerRuleInstanceDiscountContext(brcId, chargeAmount, customerId, pricingPlanId, productId, segmentationContext, orderScenario, existingDiscountIds) {
  return function (dispatch) {
    return retrieveBillerRuleInstanceDiscountContextPromise(dispatch, brcId, chargeAmount, customerId, pricingPlanId, productId, segmentationContext, orderScenario, existingDiscountIds);
  };
};
var retrieveBillerRuleInstanceDiscountContextPromise = function retrieveBillerRuleInstanceDiscountContextPromise(dispatch, brcId, chargeAmount, customerId, pricingPlanId, productId, segmentationContext, orderScenario) {
  var existingDiscountIds = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
  return ThunkHelper(dispatch, RETRIEVE_BILLER_RULE_INSTANCE_DISCOUNT_CONTEXT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveBillerRuleInstanceDiscountContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      BillerRuleConfigurationId: brcId,
      ChargeAmount: chargeAmount,
      ExistingDiscountIds: existingDiscountIds,
      ProductPricingPlanOrderScenario: orderScenario,
      PricingPlanId: {
        Value: "".concat(pricingPlanId)
      },
      ProductId: {
        Value: "".concat(productId)
      },
      SegmentationContext: segmentationContext
    }
  });
};
export var setDecisionsSelectedPageId = function setDecisionsSelectedPageId(pageId) {
  return {
    type: SET_DECISIONS_SELECTED_PAGE,
    payload: pageId
  };
};
export var setSelectedBriSelectedDiscounts = function setSelectedBriSelectedDiscounts(selectedDiscountInfo) {
  return {
    type: SET_SELECTED_BRI_SELECTED_DISCOUNTS,
    payload: selectedDiscountInfo
  };
};
export var decisionOptionSelected = function decisionOptionSelected(decisionId, optionId) {
  return {
    type: DECISION_OPTION_SELECTED,
    payload: {
      decisionId: decisionId,
      optionId: optionId
    }
  };
};
export var decisionOptionQuantityChanged = function decisionOptionQuantityChanged(quantity, decisionId, optionId, shouldResetOtherDecisionOptionsQuantityToZero) {
  return {
    type: DECISION_OPTION_QUANTITY_CHANGED,
    payload: {
      decisionId: decisionId,
      optionId: optionId,
      quantity: quantity,
      shouldResetOtherDecisionOptionsQuantityToZero: shouldResetOtherDecisionOptionsQuantityToZero
    }
  };
};
export var decisionOptionItemQuantityChanged = function decisionOptionItemQuantityChanged(itemId, quantity, decisionId, optionId) {
  return {
    type: DECISION_OPTION_ITEM_QUANTITY_CHANGED,
    payload: {
      decisionId: decisionId,
      itemId: itemId,
      optionId: optionId,
      quantity: quantity
    }
  };
};
export var discountOverrideChanged = function discountOverrideChanged(decisionId, optionId, billerRuleConfigurationId, selectedDiscountsInfo) {
  return {
    type: DISCOUNT_OVERRIDE_CHANGED,
    payload: {
      decisionId: decisionId,
      optionId: optionId,
      billerRuleConfigurationId: billerRuleConfigurationId,
      selectedDiscountsInfo: selectedDiscountsInfo
    }
  };
};
export var nonDecisionGroupOptionQuantityChanged = function nonDecisionGroupOptionQuantityChanged(quantity, decisionId, optionId) {
  return {
    type: MAX_ONE_NON_DECISION_GROUP_OPTION_QUANTITY_CHANGED,
    payload: {
      decisionId: decisionId,
      optionId: optionId,
      quantity: quantity,
      shouldResetOtherDecisionOptionsQuantityToZero: true
    }
  };
};
export var clearDiscountOverride = function clearDiscountOverride(decisionId, optionId) {
  return {
    type: DISCOUNT_OVERRIDE_CLEAR,
    payload: {
      decisionId: decisionId,
      optionId: optionId
    }
  };
};
export var decisionOptionServiceIdsForRemovalSelected = function decisionOptionServiceIdsForRemovalSelected(decisionId, optionId, serviceIds) {
  return {
    type: DECISION_OPTION_SERVICE_IDS_FOR_REMOVAL_SELECTED,
    payload: {
      decisionId: decisionId,
      optionId: optionId,
      serviceIds: serviceIds
    }
  };
};
export var keywordSearch = function keywordSearch(postalCode, subscriberCategory, subscriberTypeCode, customerLanguage, additionalOptions, contextOfferingAction) {
  return function (dispatch) {
    performSearchPromise(dispatch, postalCode, subscriberCategory, subscriberTypeCode, customerLanguage, additionalOptions, contextOfferingAction);
  };
};
export var performSearchPromise = function performSearchPromise(dispatch, postalCode, subscriberCategory, subscriberTypeCode, customerLanguage, additionalOptions, contextOfferingAction) {
  // TODO: Customer Order - We should not be pulling in the reduxStore here, as actions should have no knowledge of
  // selector logic. The data should be passed in. Don't follow this pattern, will be refactored in the future.
  var $ngRedux = InjectorHelper.getNgReduxService();
  var pageNumber = additionalOptions.pageNumber || 1;
  var pageSize = additionalOptions.pageSize || 25;
  var offerChargeType;
  var offerChargeTypeIds = additionalOptions.chargeTypeIdsSelector($ngRedux.getState());
  if (offerChargeTypeIds && offerChargeTypeIds.length === 1) {
    offerChargeType = OFFERING_CHARGE_TYPE_IDS[offerChargeTypeIds[0]];
  }
  var data = {
    ContractId: getContractId(),
    CurrencyCode: additionalOptions.currencyCode || undefined,
    Facets: additionalOptions.facetIdsSelector($ngRedux.getState()),
    OfferingChargeType: offerChargeType,
    Action: contextOfferingAction,
    OrderScenario: additionalOptions.orderScenario,
    PageNumber: pageNumber,
    PageSize: pageSize,
    SearchString: additionalOptions.keyword,
    SegmentationContext: [{
      'Key': 'zipcode',
      'Value': postalCode
    }, {
      'Key': 'subscriber_category',
      'Value': subscriberCategory
    }, {
      'Key': 'subscriber_type',
      'Value': subscriberTypeCode
    }],
    SortBy: OFFERINGS_SEARCH_CONSTANTS.SORT_BY.RELEVANCE,
    SortDirection: OFFERINGS_SEARCH_CONSTANTS.SORT_DIRECTION.DESCENDING
  };
  if (additionalOptions.subtenants) {
    data['Subtenants'] = additionalOptions.subtenants;
  }
  searchAvailableOfferingsPromise(dispatch, data, {
    pageNumber: pageNumber
  }, customerLanguage).catch(function () {
    getUiNotificationService().error(i18n.translate(CustomerCareKeys.OFFERINGS_ERROR), null, {
      timeOut: NOTIFICATION_TIME_LENGTH
    });
  });
};
export var keywordSearchWithCustomerId = function keywordSearchWithCustomerId(customerId, additionalOpts, contextOfferingAction, OfferType) {
  return function (dispatch) {
    performSearchPromiseWithCustomerId(dispatch, customerId, additionalOpts, contextOfferingAction, OfferType);
  };
};
export var performSearchPromiseWithCustomerId = function performSearchPromiseWithCustomerId(dispatch, customerId, additionalOpts, contextOfferingAction, OfferType) {
  // TODO: Customer Order - We should not be pulling in the reduxStore here, as actions should have no knowledge of
  // selector logic. The data should be passed in. Don't follow this pattern, will be refactored in the future.
  var $ngRedux = InjectorHelper.getNgReduxService();
  var pageNumber = additionalOpts.pageNumber || 1;
  var pageSize = additionalOpts.pageSize || 25;
  var offerChargeType;
  var offerChargeTypeIds = additionalOpts.chargeTypeIdsSelector($ngRedux.getState());
  if (offerChargeTypeIds && offerChargeTypeIds.length === 1) {
    offerChargeType = OFFERING_CHARGE_TYPE_IDS[offerChargeTypeIds[0]];
  }
  searchAvailableOfferingsPromise(dispatch, {
    ContractId: getContractId(),
    CurrencyCode: additionalOpts.currencyCode || undefined,
    Facets: additionalOpts.facetIdsSelector($ngRedux.getState()),
    OfferingChargeType: offerChargeType,
    Action: contextOfferingAction,
    NonBulkOfferingsOnly: additionalOpts.nonBulkOnly,
    OrderScenario: additionalOpts.orderScenario,
    OfferType: OfferType || additionalOpts.offerType,
    PageNumber: pageNumber,
    PageSize: pageSize,
    SearchString: additionalOpts.keyword,
    SortBy: OFFERINGS_SEARCH_CONSTANTS.SORT_BY.RELEVANCE,
    SortDirection: OFFERINGS_SEARCH_CONSTANTS.SORT_DIRECTION.DESCENDING
  }, additionalOpts.pageNumber, undefined, customerId).catch(function () {
    getUiNotificationService().error(i18n.translate(CustomerCareKeys.OFFERINGS_ERROR), null, {
      timeOut: NOTIFICATION_TIME_LENGTH
    });
  });
};
export var searchInventoryPromise = function searchInventoryPromise(dispatch, inventoryTypeId) {
  var searchPatterns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var customerId = arguments.length > 3 ? arguments[3] : undefined;
  return ThunkHelper(dispatch, SEARCH_INVENTORY_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchInventory',
    data: {
      InventoryTypeId: inventoryTypeId,
      PageSize: 6,
      SearchPatterns: searchPatterns
    },
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var clearQuote = function clearQuote() {
  return {
    type: CLEAR_QUOTE
  };
};
export var clearSummaryQuote = function clearSummaryQuote() {
  return {
    type: CLEAR_SUMMARY_QUOTE
  };
};
export var setSelectedOfferName = function setSelectedOfferName(offerName) {
  return {
    type: SET_SELECTED_OFFER_NAME,
    payload: offerName
  };
};
export var resetAvailableInventoryInformation = function resetAvailableInventoryInformation() {
  return {
    type: RESET_AVAILABLE_INVENTORY_INFORMATION
  };
};
export var SET_OFFERING_PAGE_SIZE_PREFERENCE = 'SET_OFFERING_PAGE_SIZE_PREFERENCE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: SET_OFFERING_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var SET_PURCHASE_ORDER_NUMBER = 'SET_OFFERING_PURCHASE_ORDER_NUMBER';
export var setPurchaseOrderNumber = function setPurchaseOrderNumber(poNumber) {
  return {
    type: SET_PURCHASE_ORDER_NUMBER,
    payload: poNumber
  };
};
export var SET_CHANGES_EFFECTIVE = 'SET_CHANGES_EFFECTIVE';
export var setChangesEffective = function setChangesEffective(changesEffective) {
  return {
    type: SET_CHANGES_EFFECTIVE,
    payload: changesEffective
  };
};
export var SET_EXTERNAL_CONTRACT_ID = 'SET_OFFERING_EXTERNAL_CONTRACT_ID';
export var setExternalContractId = function setExternalContractId(externalContractId) {
  return {
    type: SET_EXTERNAL_CONTRACT_ID,
    payload: externalContractId
  };
};
export var SET_ACTIVE_ATTRIBUTE_FORM_NAME = 'SET_ACTIVE_ATTRIBUTE_FORM_NAME';
export var setActiveAttributeFormName = function setActiveAttributeFormName(payload) {
  return {
    type: SET_ACTIVE_ATTRIBUTE_FORM_NAME,
    payload: payload
  };
};
export var SET_EXECUTION_OPTIONS = 'SET_OFFERING_EXECUTION_OPTIONS';
export var setExecutionOptions = function setExecutionOptions(executionOptions) {
  return {
    type: SET_EXECUTION_OPTIONS,
    payload: executionOptions
  };
};
export var SET_ORDER_DETAILS = 'SET_ORDER_DETAIL_OPTIONS';
export var setOrderDetails = function setOrderDetails(orderDetails) {
  return {
    type: SET_ORDER_DETAILS,
    payload: orderDetails
  };
};
export var SET_DEVICE_PAYMENT_OPTIONS = 'SET_DEVICE_PAYMENT_OPTIONS';
export var setDevicePaymentOptions = function setDevicePaymentOptions(items) {
  return {
    type: SET_DEVICE_PAYMENT_OPTIONS,
    payload: items
  };
};
export var BEGIN_EDIT_OFFER_ORDER = 'BEGIN_EDIT_OFFER_ORDER';
export var beginEditOfferOrder = function beginEditOfferOrder() {
  return {
    type: BEGIN_EDIT_OFFER_ORDER
  };
};
export var startEditOfferFlow = function startEditOfferFlow(offerName) {
  return function (dispatch) {
    dispatch(beginEditOfferOrder());
    dispatch(setSelectedOfferName(offerName));
  };
};
export var getContractId = function getContractId() {
  // returns contract id from either RouteParams or SelectedContractSelector
  // if RouteParams are null, use SelectedContractSelector
  // if using SelectedContractSelector, we want the OrderContractId for existing orders
  // otherwise, we want the id for new connect.

  // TODO: Customer Order - We should not be pulling in the reduxStore here, as actions should have no knowledge of
  // selector logic. The data should be passed in. Don't follow this pattern, will be refactored in the future.
  var $ngRedux = InjectorHelper.getNgReduxService();
  var contract = SelectedContractSelector($ngRedux.getState());
  var routeParams = RouteParams($ngRedux.getState());
  var contractId = null;
  if (routeParams.contractId && routeParams.contractInstanceId) {
    contractId = routeParams.contractId;
  }
  return contractId || contract ? contractId || contract.OrderContractId || contract.Id : null;
};
export var getContractInstance = function getContractInstance(offeringId) {
  // returns order contract instance from either routeParams or selectedOfferings/selectedContract
  // if routeParams are null, use selectedOfferings/selectedContract

  // TODO: Customer Order - We should not be pulling in the reduxStore here, as actions should have no knowledge of
  // selector logic. The data should be passed in. Don't follow this pattern, will be refactored in the future.
  var $ngRedux = InjectorHelper.getNgReduxService();
  var routeParams = RouteParams($ngRedux.getState());
  var selectedOfferings = ConvergentBillerAccountOfferingsForSelectedAccountSelector($ngRedux.getState());
  var selectedContract = selectedOfferings ? selectedOfferings.find(function (offering) {
    return offeringId === offering.OfferingId;
  }) : null;
  var orderContractInstance = null;
  if (routeParams.contractId && routeParams.contractInstanceId) {
    orderContractInstance = {
      Id: routeParams.contractInstanceId,
      OrderContractId: routeParams.contractId
    };
  }
  return orderContractInstance || selectedContract && selectedContract.OrderContractInstance ? orderContractInstance || selectedContract.OrderContractInstance : null;
};
export var SET_ACTIVE_FORM_VALIDATION_STATUS = 'SET_ACTIVE_FORM_VALIDATION_STATUS';
export var setActiveFormValidationStatus = function setActiveFormValidationStatus(payload) {
  return {
    type: SET_ACTIVE_FORM_VALIDATION_STATUS,
    payload: payload
  };
};
export var SET_ATTRIBUTE_FORM_SUBMITTED = 'SET_ATTRIBUTE_FORM_SUBMITTED';
export var setAttributeFormSubmitted = function setAttributeFormSubmitted(payload) {
  return {
    type: SET_ATTRIBUTE_FORM_SUBMITTED,
    payload: payload
  };
};

// To be invoked only for MultiOffer shopping cart. Single Offer shopping cart doesn't require this.
var updateShoppingCartPromise = function updateShoppingCartPromise(dispatch, reduxEvents, customerId, shoppingCart, isAppendToCart) {
  return ThunkHelper(dispatch, reduxEvents, {
    method: 'post',
    url: 'SubscriberManagement/UpdateShoppingCart',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      AppendToCart: isAppendToCart,
      CombineProducts: false,
      PersistCart: true,
      ShoppingCart: shoppingCart
    }
  });
};
export var updateMultiOfferShoppingCartPromise = function updateMultiOfferShoppingCartPromise(dispatch, customerId, shoppingCart) {
  var isAppendToCart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return updateShoppingCartPromise(dispatch, UPDATE_MULTI_OFFER_SHOPPING_CART_EVENTS, customerId, shoppingCart, isAppendToCart);
};
export var updateMultiOfferShoppingCart = function updateMultiOfferShoppingCart(customerId, shoppingCart) {
  var isAppendToCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch) {
    return updateShoppingCartPromise(dispatch, UPDATE_MULTI_OFFER_SHOPPING_CART_EVENTS, customerId, shoppingCart, isAppendToCart);
  };
};
export var replaceMultiOfferShoppingCart = function replaceMultiOfferShoppingCart(customerId, shoppingCart) {
  var isAppendToCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch) {
    return updateShoppingCartPromise(dispatch, REPLACE_MULTI_OFFER_SHOPPING_CART_EVENTS, customerId, shoppingCart, isAppendToCart);
  };
};
export var searchTelephoneNumberInventory = function searchTelephoneNumberInventory(inventoryTypeId) {
  var searchPatterns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (dispatch, getState) {
    var routeParams = RouteParams(getState());
    return searchInventoryPromise(dispatch, inventoryTypeId, searchPatterns, routeParams.customerId);
  };
};
export var SET_SELECTED_INVENTORY_STORES = 'SET_SELECTED_INVENTORY_STORES';
export var setSelectedInventoryStores = function setSelectedInventoryStores(stores) {
  return {
    type: SET_SELECTED_INVENTORY_STORES,
    payload: stores
  };
};
export var SET_INVENTORY_REGION_FILTER = 'SET_INVENTORY_REGION_FILTER';
export var setInventoryRegionFilter = function setInventoryRegionFilter(region) {
  return {
    type: SET_INVENTORY_REGION_FILTER,
    payload: region
  };
};
export var SET_INVENTORY_STORE_CHANGED_FLAG = 'SET_INVENTORY_STORE_CHANGED_FLAG';
export var setInventoryStoreChangedFlag = function setInventoryStoreChangedFlag(isStoreChanged) {
  return {
    type: SET_INVENTORY_STORE_CHANGED_FLAG,
    payload: isStoreChanged
  };
};
var searchServiceFeaturesPromise = function searchServiceFeaturesPromise(dispatch, serviceId, customerId, postalCode, subscriberCategory, subscriberTypeCode) {
  return ThunkHelper(dispatch, SEARCH_SERVICE_FEATURES_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchCatalog',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId || undefined),
    data: {
      ProductFilter: {
        ProductClassification: PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE,
        ServiceId: serviceId
      },
      SearchEntities: [SEARCH_ENTITIES.PRODUCT],
      SegmentationContext: [{
        'Key': 'subscriber_category',
        'Value': subscriberCategory
      }, {
        'Key': 'subscriber_type',
        'Value': subscriberTypeCode
      }, {
        'Key': 'zipcode',
        'Value': postalCode
      }],
      ProductSort: {
        SortBy: SORT_BY.REFERENCE_DATE,
        SortDirection: SORT_DIRECTION.DESCENDING
      }
    }
  });
};
export var searchServiceFeatures = function searchServiceFeatures(serviceId, customerId) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    postalCode = _ref2.postalCode,
    Category = _ref2.Category,
    SubscriberTypeCode = _ref2.SubscriberTypeCode;
  return function (dispatch) {
    return searchServiceFeaturesPromise(dispatch, serviceId, customerId, postalCode, Category, SubscriberTypeCode);
  };
};
var getServiceFeatureProductMetadataPromise = function getServiceFeatureProductMetadataPromise(dispatch, productId, language) {
  return MetadataThunkHelper(dispatch, GET_SERVICE_FEATURE_PRODUCT_METADATA_EVENTS, {
    url: "Product/Id/".concat(productId),
    headers: _defineProperty({}, LANGUAGE_HEADER, language || undefined)
  });
};
export var getServiceFeatureProduct = function getServiceFeatureProduct(productId, language) {
  return function (dispatch) {
    return getServiceFeatureProductMetadataPromise(dispatch, productId, language);
  };
};
var getStandaloneProductMetadataPromise = function getStandaloneProductMetadataPromise(dispatch, productId, language) {
  return MetadataThunkHelper(dispatch, GET_STANDALONE_PRODUCT_METADATA_EVENTS, {
    url: "Product/Id/".concat(productId),
    headers: _defineProperty({}, LANGUAGE_HEADER, language || undefined)
  });
};
export var getStandaloneProduct = function getStandaloneProduct(productId, language) {
  return function (dispatch) {
    return getStandaloneProductMetadataPromise(dispatch, productId, language);
  };
};
var retrieveProductContextForServiceFeaturesPromise = function retrieveProductContextForServiceFeaturesPromise(dispatch, productId, serviceId, customerId, orderScenario) {
  return ThunkHelper(dispatch, RETRIEVE_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveProductContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId || undefined),
    data: {
      IncludeOrderablePricingPlans: true,
      ProductId: productId,
      ProductPricingPlanOrderScenario: orderScenario,
      ServiceId: serviceId
    }
  });
};
export var retrieveProductContextForServiceFeatures = function retrieveProductContextForServiceFeatures(productId, serviceId, customerId, orderScenario) {
  return function (dispatch) {
    return retrieveProductContextForServiceFeaturesPromise(dispatch, productId, serviceId, customerId, orderScenario);
  };
};
export var clearProductContextForServiceFeatures = function clearProductContextForServiceFeatures() {
  return {
    type: CLEAR_PRODUCT_CONTEXT_FOR_SERVICE_FEATURES
  };
};
export var resetInventoryStorePickupDetails = function resetInventoryStorePickupDetails() {
  return {
    type: RESET_INVENTORY_STORE_PICKUP_DETAILS
  };
};
export var saveInventoryStorePickupDetails = function saveInventoryStorePickupDetails(payload) {
  return {
    type: SAVE_INVENTORY_STORE_PICKUP_DETAILS,
    payload: payload
  };
};
export var sendInventoryToStorePromise = function sendInventoryToStorePromise(dispatch, customerId, shoppingCart, pickupDetails, offering, completedDecisions, transitionIds) {
  return ThunkHelper(dispatch, SEND_INVENTORY_TO_STORE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SendShoppingCartToStore',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      CompletedDecisionsList: completedDecisions,
      Offering: offering,
      ShoppingCart: shoppingCart,
      SubscriberPhysicalInventoryPickup: {
        Comments: pickupDetails.comments,
        Id: pickupDetails.id,
        PickupDate: pickupDetails.date
      },
      TransitionSourceOfferingId: transitionIds ? transitionIds.transitionSourceOfferingId : null,
      TransitionSourceOfferingInstanceId: transitionIds ? transitionIds.transitionSourceOfferingInstanceId : null
    }
  });
};
export var RETRIEVE_OFFCYCLE_ALIGNMENT_OPTIONS = {
  BEGIN: 'RETRIEVE_OFFCYCLE_ALIGNMENT_OPTIONS_BEGIN',
  SUCCESS: 'RETRIEVE_OFFCYCLE_ALIGNMENT_OPTIONS_SUCCESS',
  FAILURE: 'RETRIEVE_OFFCYCLE_ALIGNMENT_OPTIONS_FAILURE'
};
export var retrieveOffCycleAlignmentOptions = function retrieveOffCycleAlignmentOptions(data, customerId) {
  return function (dispatch) {
    return retrieveOffCycleAlignmentOptionsPromise(dispatch, data, customerId);
  };
};
var retrieveOffCycleAlignmentOptionsPromise = function retrieveOffCycleAlignmentOptionsPromise(dispatch, data, customerId) {
  var params = {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOffCycleAlignmentOptions',
    headers: addSubscriberHeaders(customerId),
    data: {
      ProductAndPricingPlanIds: data
    }
  };
  return ThunkHelper(dispatch, Object.values(RETRIEVE_OFFCYCLE_ALIGNMENT_OPTIONS), params);
};
export var sendInventoryToStore = function sendInventoryToStore(customerId, shoppingCart, pickupDetails, offering, completedDecisions, transitionIds) {
  return function (dispatch) {
    return sendInventoryToStorePromise(dispatch, customerId, shoppingCart, pickupDetails, offering, completedDecisions, transitionIds);
  };
};
var retrieveTransferFromSubscriberPromise = function retrieveTransferFromSubscriberPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_TRANSFER_FROM_SUBSCRIBER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriber',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveTransferFromSubscriber = function retrieveTransferFromSubscriber(customerId) {
  return function (dispatch) {
    return retrieveTransferFromSubscriberPromise(dispatch, customerId);
  };
};
export var SEARCH_SUBSCRIBER_OFFERINGS_CONSTANTS = {
  BEGIN: 'SEARCH_SUBSCRIBER_OFFERINGS_BEGIN',
  SUCCESS: 'SEARCH_SUBSCRIBER_OFFERINGS_SUCCESS',
  FAILURE: 'SEARCH_SUBSCRIBER_OFFERINGS_FAILURE'
};
export var searchSubscriberOfferingsPromise = function searchSubscriberOfferingsPromise(dispatch, params, requestObj) {
  return ThunkHelper(dispatch, values(SEARCH_SUBSCRIBER_OFFERINGS_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/SearchSubscriberOfferings',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, params.customerId),
    data: {
      IncludeCoolingOff: true,
      IncludeOfferingTotals: params.includeOfferingTotals,
      OfferingInstanceIds: params.offeringInstanceIds,
      OfferName: params.offerName,
      PageNumber: params.pageNumber,
      PageSize: params.pageSize,
      Status: params.status
    }
  }, requestObj);
};
export var searchSubscriberOfferings = function searchSubscriberOfferings(params, requestObj) {
  return function (dispatch) {
    return searchSubscriberOfferingsPromise(dispatch, params, requestObj);
  };
};
export var SET_OFFERING_FILTER_DATA = 'SET_OFFERING_FILTER_DATA';
export var setOfferingFilterData = function setOfferingFilterData(searchBy, searchTerm, filterBy) {
  return {
    type: SET_OFFERING_FILTER_DATA,
    payload: {
      searchBy: searchBy,
      searchTerm: searchTerm,
      filterBy: filterBy
    }
  };
};
export var SET_OFFERING_PAGINATION_DATA = 'SET_OFFERING_PAGINATION_DATA';
export var setOfferingPaginationData = function setOfferingPaginationData(pageNumber, pageSize) {
  return {
    type: SET_OFFERING_PAGINATION_DATA,
    payload: {
      pageNumber: pageNumber,
      pageSize: pageSize
    }
  };
};
export var SET_SAVED_LIFE_CYCLE_ID = 'SET_SAVED_LIFE_CYCLE_ID';
export var setSavedLifeCycleId = function setSavedLifeCycleId(lifeCycleId, optionId, decisionId) {
  return {
    type: SET_SAVED_LIFE_CYCLE_ID,
    payload: {
      lifeCycleId: lifeCycleId,
      optionId: optionId,
      decisionId: decisionId
    }
  };
};
export var SET_DELIVERY_DECISION = 'SET_DELIVERY_DECISION';
export var updateDeliveryDecision = function updateDeliveryDecision(selectedValue) {
  return {
    type: SET_DELIVERY_DECISION,
    payload: {
      selectedValue: selectedValue
    }
  };
};
export var SET_SERVICE_TAX_LOCATION_DECISION = 'SET_SERVICE_TAX_LOCATION_DECISION';
export var updateServiceTaxLocationDecision = function updateServiceTaxLocationDecision(payload) {
  return {
    type: SET_SERVICE_TAX_LOCATION_DECISION,
    payload: payload
  };
};
export var setOffCycleAlignmentSubscriberProductData = function setOffCycleAlignmentSubscriberProductData(payload) {
  return {
    type: SET_OFF_CYCLE_ALIGNMENT_SUBSCRIBER_PRODUCT_DATA,
    payload: payload
  };
};
export var SET_SELECTED_DELIVERY_DECISION = 'SET_SELECTED_DELIVERY_DECISION';
export var setDeliveryDecision = function setDeliveryDecision(decision) {
  return {
    type: SET_SELECTED_DELIVERY_DECISION,
    payload: decision
  };
};
export var SET_SELECTED_ADDRESS = 'SET_SELECTED_ADDRESS';
export var updateShippingDetails = function updateShippingDetails(address) {
  return {
    type: SET_SELECTED_ADDRESS,
    payload: address
  };
};
export var SET_SELECTED_SHIPPING_ADDRESS = 'SET_SELECTED_SHIPPING_ADDRESS';
export var setSelectedShippingAddress = function setSelectedShippingAddress(address) {
  return {
    type: SET_SELECTED_SHIPPING_ADDRESS,
    payload: address
  };
};
export var SET_UPDATED_SHIPPING_ADDRESS = 'SET_UPDATED_SHIPPING_ADDRESS';
export var setUpdatedShippingAddress = function setUpdatedShippingAddress(address) {
  return {
    type: SET_UPDATED_SHIPPING_ADDRESS,
    payload: address
  };
};
export var SUSPEND_OFFER = {
  BEGIN: 'SUSPEND_OFFER_BEGIN',
  SUCCESS: 'SUSPEND_OFFER_SUCCESS',
  FAILURE: 'SUSPEND_OFFER_FAILURE'
};
var SUSPEND_OFFER_EVENTS = [SUSPEND_OFFER.BEGIN, SUSPEND_OFFER.SUCCESS, SUSPEND_OFFER.FAILURE];
function suspendOfferPromise(dispatch, payload, customerId) {
  return ThunkHelper(dispatch, SUSPEND_OFFER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/GroupSuspendServices',
    data: payload,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
}
export function suspendOffer(payload, customerId) {
  return function (dispatch) {
    return suspendOfferPromise(dispatch, payload, customerId);
  };
}
export var RESUME_OFFER = {
  BEGIN: 'RESUME_OFFER_BEGIN',
  SUCCESS: 'RESUME_OFFER_SUCCESS',
  FAILURE: 'RESUME_OFFER_FAILURE'
};
var RESUME_OFFER_EVENTS = [RESUME_OFFER.BEGIN, RESUME_OFFER.SUCCESS, RESUME_OFFER.FAILURE];
function resumeOfferPromise(dispatch, payload, customerId) {
  return ThunkHelper(dispatch, RESUME_OFFER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/GroupRestoreServices',
    data: payload,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
}
export function resumeOffer(payload, customerId) {
  return function (dispatch) {
    return resumeOfferPromise(dispatch, payload, customerId);
  };
}